import styled from 'styled-components';
import { tokens } from 'components/v3';

export const TabsCard = styled.div`
  background: ${({ theme }) => tokens(theme).card};
  border: 1px solid ${({ theme }) => tokens(theme).border};
  border-radius: 16px;
  box-shadow: ${({ theme }) => tokens(theme).shadowCard};
  margin-bottom: 24px;
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const StatsContainer = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
`;

export const MiniStatCard = styled.div`
  background: ${({ theme }) => tokens(theme).inset};
  border: 1px solid ${({ theme }) => tokens(theme).border};
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 100px;

  @media (max-width: 768px) {
    flex: 1;
    min-width: 0;
  }
`;

export const MiniStatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 4px;
  color: ${({ color, theme }) => color || tokens(theme).text};
`;

export const MiniStatLabel = styled.div`
  font-size: 11px;
  color: ${({ theme }) => tokens(theme).sub};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const PageTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => tokens(theme).text};
  margin: 0 0 4px 0;
`;

export const PageDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) => tokens(theme).sub};
  margin: 0;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const TopicCard = styled.div`
  padding: 20px;
  background: ${({ theme }) => tokens(theme).card};
  border: 1px solid ${({ theme }) => tokens(theme).border};
  border-radius: 12px;
  box-shadow: ${({ theme }) => tokens(theme).shadowCard};
  transition: all 0.2s;

  &:hover {
    box-shadow: ${({ theme }) => tokens(theme).shadowPop};
  }
`;

export const TopicHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const TopicTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => tokens(theme).text};
  margin: 0 0 4px 0;
`;

export const TopicDescription = styled.p`
  font-size: 14px;
  color: ${({ theme }) => tokens(theme).sub};
  margin: 0 0 12px 0;
`;

export const TopicFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid ${({ theme }) => tokens(theme).line};
`;

export const TopicCount = styled.span`
  font-size: 14px;
  color: ${({ theme }) => tokens(theme).sub};
`;

export const SettingsCard = styled.div`
  background: ${({ theme }) => tokens(theme).card};
  border: 1px solid ${({ theme }) => tokens(theme).border};
  border-radius: 16px;
  box-shadow: ${({ theme }) => tokens(theme).shadowCard};
  margin-bottom: 20px;
`;

export const SettingsRow = styled.div`
  padding: 24px;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => tokens(theme).line};
  }
`;
